import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const DrawerFilledIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M8.25 2.75C7.91848 2.75 7.60054 2.8817 7.36612 3.11612C7.1317 3.35054 7 3.66848 7 4C7 4.33152 7.1317 4.64946 7.36612 4.88388C7.60054 5.1183 7.91848 5.25 8.25 5.25H15.75C16.0815 5.25 16.3995 5.1183 16.6339 4.88388C16.8683 4.64946 17 4.33152 17 4C17 3.66848 16.8683 3.35054 16.6339 3.11612C16.3995 2.8817 16.0815 2.75 15.75 2.75H8.25ZM4.5 7.75C4.5 7.41848 4.6317 7.10054 4.86612 6.86612C5.10054 6.6317 5.41848 6.5 5.75 6.5H18.25C18.5815 6.5 18.8995 6.6317 19.1339 6.86612C19.3683 7.10054 19.5 7.41848 19.5 7.75C19.5 8.08152 19.3683 8.39946 19.1339 8.63388C18.8995 8.8683 18.5815 9 18.25 9H5.75C5.41848 9 5.10054 8.8683 4.86612 8.63388C4.6317 8.39946 4.5 8.08152 4.5 7.75ZM2 12.75C2 12.087 2.26339 11.4511 2.73223 10.9822C3.20107 10.5134 3.83696 10.25 4.5 10.25H19.5C20.163 10.25 20.7989 10.5134 21.2678 10.9822C21.7366 11.4511 22 12.087 22 12.75V17.75C22 18.413 21.7366 19.0489 21.2678 19.5178C20.7989 19.9866 20.163 20.25 19.5 20.25H4.5C3.83696 20.25 3.20107 19.9866 2.73223 19.5178C2.26339 19.0489 2 18.413 2 17.75V12.75Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

DrawerFilledIcon.displayName = 'DrawerFilledIcon';
